export default __webpack_public_path__ + "static/media/man5.0e14fdc8.JPG";